import { render } from "./InputCheckboxGroup.vue?vue&type=template&id=32be8602"
import script from "./InputCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./InputCheckboxGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__